const state = {
 reload_company_pre_agreement: false,
};

const actions = {};

const mutations = {
 RELOAD_PRE_AGREEMENT(state, payload) {
  state.reload_company_pre_agreement = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
